export default "__VITE_ASSET__026dd938__"